class ShippingEstimate extends HTMLElement {
  constructor() {
    super();
    this.countdownEl = this.querySelector('.shipping-countdown');
    this.dateEl = this.querySelector('.shipping-date');
    this.deliveryEl = this.querySelector('.shipping-delivery');
    
    this.cutoffHour = parseInt(this.dataset.cutoff) || 14;
    this.processingDays = parseInt(this.dataset.processing) || 0;
    this.deliveryMin = parseInt(this.dataset.deliveryMin) || 3;
    this.deliveryMax = parseInt(this.dataset.deliveryMax) || 5;
    this.tzOffset = this.dataset.tz ? parseFloat(this.dataset.tz) : null;
    this.excludeWeekends = this.dataset.weekends === 'true';

    this.monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    this.monthNamesFull = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    
    this.init();
  }

  init() {
    this.updateEstimate();
    // Update every minute (60,000ms)
    this.interval = setInterval(() => this.updateEstimate(), 60000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  getStoreTime() {
    const now = new Date();
    if (this.tzOffset === null || isNaN(this.tzOffset)) return now; 
    
    // convert local to UTC
    const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
    // add exact store tz offset 
    return new Date(utc + (3600000 * this.tzOffset));
  }

  isWeekend(date) {
    return date.getDay() === 0 || date.getDay() === 6;
  }

  addBusinessDays(date, daysToAdd) {
    const d = new Date(date);
    if (!this.excludeWeekends) {
      d.setDate(d.getDate() + daysToAdd);
      return d;
    }

    let added = 0;
    // If we start on a weekend, push to Monday immediately before counting "days to add"
    while (this.isWeekend(d)) {
      d.setDate(d.getDate() + 1);
    }

    while (added < daysToAdd) {
      d.setDate(d.getDate() + 1);
      if (!this.isWeekend(d)) {
        added++;
      }
    }
    return d;
  }

  formatDate(date, shortMonth) {
    const m = shortMonth ? this.monthNames[date.getMonth()] : this.monthNamesFull[date.getMonth()];
    const d = date.getDate();
    return `${m} ${d}`;
  }

  updateEstimate() {
    const storeTime = this.getStoreTime();
    
    // Determine today's cutoff boundary 
    const cutoffTimeToday = new Date(storeTime);
    cutoffTimeToday.setHours(this.cutoffHour, 0, 0, 0);

    let isPastCutoff = storeTime >= cutoffTimeToday;
    
    // Calculate countdown
    let nextCutoff = new Date(cutoffTimeToday);
    if (isPastCutoff) {
      nextCutoff.setDate(nextCutoff.getDate() + 1);
    }
    
    const diffMs = nextCutoff - storeTime;
    const diffHrs = Math.floor(diffMs / 3600000);
    const diffMins = Math.floor((diffMs % 3600000) / 60000);
    
    if (this.countdownEl) {
      this.countdownEl.textContent = `${diffHrs} hrs ${diffMins} mins`;
    }

    // Date calculations
    let baseDate = new Date(storeTime);
    baseDate.setHours(0, 0, 0, 0);

    let daysToShip = this.processingDays;
    
    // If it's past cutoff, we shift the processing baseline to the next day
    if (isPastCutoff) {
      daysToShip += 1;
    }

    // Final Ship Date
    let shipDate = this.addBusinessDays(baseDate, daysToShip);

    if (this.dateEl) {
      this.dateEl.textContent = this.formatDate(shipDate, false);
    }

    // Delivery Dates
    let deliveryStart = this.addBusinessDays(shipDate, this.deliveryMin);
    let deliveryEnd = this.addBusinessDays(shipDate, this.deliveryMax);

    if (this.deliveryEl) {
      const startStr = this.formatDate(deliveryStart, true);
      const endStr = this.formatDate(deliveryEnd, true);
      
      // e.g. Mar 4 to 6
      if (deliveryStart.getMonth() === deliveryEnd.getMonth() && deliveryStart.getDate() !== deliveryEnd.getDate()) {
        this.deliveryEl.textContent = `${startStr} to ${deliveryEnd.getDate()}`;
      } else if (deliveryStart.getTime() === deliveryEnd.getTime()) {
        this.deliveryEl.textContent = `${startStr}`;
      } else {
        this.deliveryEl.textContent = `${startStr} to ${endStr}`;
      }
    }
  }
}

if (!customElements.get('shipping-estimate')) {
  customElements.define('shipping-estimate', ShippingEstimate);
}
